module.exports = __webpack_public_path__ + "img/201_202_203_204.6010ecab.png";